import { useEffect, useState } from "react";
import { X, Gift, ArrowRight } from "lucide-react";
import { Link } from "react-router-dom";
import { useT } from "@/context/LangContext";

const KEY = "negosino_promo_v1";

export default function PromoBanner() {
  const t = useT();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    setVisible(!localStorage.getItem(KEY));
  }, []);

  const dismiss = () => {
    localStorage.setItem(KEY, "1");
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="bg-[var(--ink)] text-white relative z-40" data-testid="promo-banner">
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-2.5 flex items-center gap-4">
        <Gift size={16} className="text-[var(--accent)] shrink-0 hidden sm:block" />
        <p className="text-xs sm:text-sm flex-1 truncate sm:whitespace-normal">
          {t("banner.promo")}
        </p>
        <Link
          to="/produits"
          className="text-xs font-bold uppercase tracking-widest text-[var(--accent)] hover:text-white transition-colors shrink-0 inline-flex items-center gap-1"
          data-testid="promo-cta"
        >
          {t("banner.cta")} <ArrowRight size={12} />
        </Link>
        <button
          onClick={dismiss}
          aria-label="close"
          className="text-white/50 hover:text-white transition-colors shrink-0"
          data-testid="promo-close"
        >
          <X size={16} />
        </button>
      </div>
    </div>
  );
}
